import React, { FunctionComponent } from 'react'
import { Button, Form, Input, Modal, notification } from 'antd'
import { callApi } from '../../../../context/api'

type TProps = {
	onClose: () => void
}

const ResetPasswordModal: FunctionComponent<TProps> = ({ onClose }) => {
	const [form] = Form.useForm()

	const onFinish = (values: any) => {
		callApi(`/account/reset-password`, {
			method: 'POST',
			body: {
				oldPassword: values.oldPassword,
				newPassword: values.newPassword,
			},
		})
			.then((response) => {
				if (response.ok) {
					notification.success({ message: 'Password was successfully updated' })
					onClose()
				} else {
					notification.error({ message: `An error occurred: ${response.payload.data?.message}` })
				}
			})
			.catch((error) => {
				notification.error({ message: `An error occurred: ${error.message}` })
			})
	}

	return (
		<Modal onCancel={onClose} visible={true} footer={null} title="Reset Password">
			<Form
				name="resetForm"
				className="show-validation-item"
				initialValues={{}}
				form={form}
				onFinish={onFinish}
				scrollToFirstError
				layout="vertical"
			>
				<Form.Item
					name="oldPassword"
					label="Old Password"
					rules={[{ required: true, message: 'Please input your old password!' }]}
				>
					<Input style={{ width: '100%' }} type="password" />
				</Form.Item>

				<Form.Item
					name="newPassword"
					label="New Password"
					rules={[{ required: true, message: 'Please input your new password!' }]}
				>
					<Input style={{ width: '100%' }} type="password" />
				</Form.Item>

				<Form.Item
					name="confirmPassword"
					label="Confirm New Password"
					rules={[
						{ required: true, message: 'Please confirm your password!' },
						({ getFieldValue }) => ({
							validator(_, value) {
								if (!value || getFieldValue('newPassword') === value) {
									return Promise.resolve()
								}
								return Promise.reject(new Error('The two passwords that you entered do not match!'))
							},
						}),
					]}
				>
					<Input style={{ width: '100%' }} type="password" />
				</Form.Item>

				<div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
					<Button style={{ width: '200px' }} type="primary" htmlType="submit" shape="round">
						Update
					</Button>
					<Button type="default" shape="round" onClick={onClose}>
						Cancel
					</Button>
				</div>
			</Form>
		</Modal>
	)
}

export default ResetPasswordModal
